export default "__VITE_ASSET__pRWLayQi__"